import { Button } from '@mantine/core';
import { IconSend } from '@tabler/icons-react';

interface SubmitButtonProps {
  onClick: () => void;
  loading: boolean;
  /** isOperationInProgress && !submitting bleibt Parent-State (D-06) -- aendert sich nicht pro Tastendruck. */
  disabledExtra: boolean;
}

/**
 * Einreichen-Knopf (K11/D-08): immer klickbar, ohne Schwebehinweis, ohne
 * Frontend-Gueltigkeit. Die Vollstaendigkeit prueft seit 20-02/20-03 allein das Backend
 * (Gruppe 'submit') und antwortet bei Verstoessen mit einer strukturierten 422; deren
 * Anzeige am Feld uebernimmt Plan 20-05. `disabledExtra` sperrt nur waehrend eines
 * laufenden Requests, nicht bei Unvollstaendigkeit.
 */
export function SubmitButton({ onClick, loading, disabledExtra }: SubmitButtonProps) {
  return (
    <Button
      variant="filled"
      leftSection={<IconSend size={16} />}
      onClick={onClick}
      loading={loading}
      disabled={disabledExtra}
    >
      Einreichen
    </Button>
  );
}
